module.exports = __webpack_public_path__ + "static/media/SCR-C-047.65a8157c.mp3";